import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

export const WORKSHOP_SET_CERTIFICATE_VARIABLES = {
  userFirstName: 'User_Vorname',
  userLastName: 'User_Nachname',
  userDateOfBirth: 'User_Geburtstag',
  name: 'Workshop_Reihe_Titel',
  descDe: 'Workshop_Reihe_Beschreibung_DE',
  descEn: 'Workshop_Reihe_Beschreibung_EN',
  descCertDe: 'Zertifikat_Beschreibung_DE',
  descCertEn: 'Zertifikat_Beschreibung_EN',
  createdAt: 'Erstellungs_Datum',
  workshops: {
    variable: 'workshops',
    subVariables: {
      name: 'workshop_name',
    },
  },
};

@Entity()
export class CertificateWorkshopSet extends MongoEntity {
  public static override _class = 'CertificateWorkshopSet';
  public static override _collectionName = 'certificates-workshop-set';

  @Field(type => String)
  @validate(nonOptional())
  title!: string;

  @Field(type => Date, { default: v => v ?? new Date() })
  createdAt!: Date;

  @Field(type => String)
  @validate(nonOptional())
  text!: string;

  @Field(type => String)
  fileID!: string;

  @DataLoadedField(type => AdornisFile, ({ fileID }) => fileID)
  file: Maybe<AdornisFile>;

  @validate(nonOptional())
  @Field(type => String)
  institutionID!: string;
}
